import { render } from "./AdminOverview.vue?vue&type=template&id=d9291486&scoped=true&ts=true"
import script from "./AdminOverview.vue?vue&type=script&lang=ts"
export * from "./AdminOverview.vue?vue&type=script&lang=ts"

import "./AdminOverview.vue?vue&type=style&index=0&id=d9291486&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9291486"]])

export default __exports__